import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMsg.scss';

const ErrorMsg = ({ description, title, icon = null, className = '' }) => {

const errorIcon = icon ? icon :require('./Icon/error.svg');
  return (
    <div className={`error-msg ${className}`}>
      <div className="error-content">
        {errorIcon && <span className="error-icon"><Image src={errorIcon} alt="Error" /></span>}
        {title && <div className="error-title">{title}</div>}
        {description && <div className="text">{description }</div>}
      </div>
    </div>
  );
};

ErrorMsg.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.node,
  className: PropTypes.string,
};

export default ErrorMsg;
